import React, { useState, forwardRef, useImperativeHandle } from 'react'
import {
  Avatar,
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { styled } from '@mui/material/styles'
import { updateData } from '../../api/indexedDBHandler'
const Input = styled('input')({
  display: 'none',
})

const TournamentLogoUploader = forwardRef(
  ({ initialLogoUrl = '', tournamentId }, ref) => {
    const [logo, setLogo] = useState(initialLogoUrl || null)
    const [isDialogOpen, setIsDialogOpen] = useState(false)
    const [error, setError] = useState('')

    const handleUploadClick = async (event) => {
      const file = event.target.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onloadend = async () => {
          const uploadedLogoUrl = await uploadLogoToServer(file) // Отправляем файл на сервер
          setLogo(uploadedLogoUrl) // Сохраняем URL на загруженный логотип
          // Обновляем запись в локальной базе данных
          if (uploadedLogoUrl) {
            await updateData('tournaments', tournamentId, {
              logocup: uploadedLogoUrl,
            })
          }
          setError('') // Очистить ошибку при успешной загрузке
        }
        reader.readAsDataURL(file)
      }
    }

    const uploadLogoToServer = async (file) => {
      // Эта функция выполняет загрузку файла на сервер
      const formData = new FormData()
      formData.append('logo', file)
      formData.append('tournamentId', tournamentId) // добавляем ID турнира

      const response = await fetch(
        'https://protocarp.ru/logo/cup/uploadsLogoTournaments.php',
        {
          method: 'POST',
          body: formData,
        }
      )
      if (response.ok) {
        const data = await response.json()
        return data.fileUrl // предполагаем, что сервер возвращает URL загруженного файла
      } else {
        setError('Ошибка загрузки логотипа')
        return null
      }
    }

    const handleRemoveLogo = async () => {
      // Удаление логотипа из базы данных и с сервера
      if (logo) {
        await removeLogoFromServer() // Предполагаем функцию удаления с сервера
        setLogo(null)
        await updateData('tournaments', tournamentId, { logocup: '' })
      }
    }

    const removeLogoFromServer = async () => {
      const formData = new FormData()

      formData.append('tournamentId', tournamentId)

      const response = await fetch(
        'https://protocarp.ru/logo/cup/deletelogo.php',
        {
          method: 'POST',
          body: formData,
        }
      )

      if (!response.ok) {
        setError('Ошибка удаления логотипа')
      }
    }

    const handleDialogOpen = () => {
      setIsDialogOpen(true)
    }

    const handleDialogClose = () => {
      setIsDialogOpen(false)
    }

    const validate = () => {
      if (!logo) {
        return true
      }
      setError('')
      return true
    }

    useImperativeHandle(ref, () => ({
      validate,
      val: () => logo,
    }))

    return (
      <div>
        <Typography variant="subtitle1" gutterBottom>
          Логотип соревнования
        </Typography>
        <Grid container spacing={2} alignItems="center">
          <Grid item>
            {logo ? (
              <Avatar
                src={'https://protocarp.ru/' + logo}
                alt="Tournament Logo"
                sx={{ width: 50, height: 50 }}
                variant="square"
              />
            ) : (
              <Avatar sx={{ width: 50, height: 50 }} variant="square">
                <Typography variant="caption">No Logo</Typography>
              </Avatar>
            )}
          </Grid>
          <Grid item>
            <label htmlFor="upload-logo">
              <Input
                accept="image/*"
                id="upload-logo"
                type="file"
                onChange={handleUploadClick}
              />
              <IconButton color="primary" component="span">
                {logo ? <EditIcon /> : <AddIcon />}
              </IconButton>
            </label>
          </Grid>
          {logo && (
            <Grid item>
              <IconButton color="secondary" onClick={handleRemoveLogo}>
                <DeleteIcon />
              </IconButton>
            </Grid>
          )}
          {error && (
            <Grid item xs={12}>
              <Typography color="error" variant="body2">
                {error}
              </Typography>
            </Grid>
          )}
        </Grid>

        <Dialog open={isDialogOpen} onClose={handleDialogClose}>
          <DialogTitle>Логотип Турнира</DialogTitle>
          <DialogContent>
            {logo && (
              <img
                src={logo}
                alt="Tournament Logo Large"
                style={{ width: '100%' }}
              />
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose} color="primary">
              Закрыть
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
)

export default TournamentLogoUploader
